import {
  Membership,
  CreateMembershipDTO,
  UpdateMembershipDTO,
} from "../types/Membership";
import client from "./axios";

const membershipUrl =
  "https://internal-api.getmoveapp.com/api/v1/admin/memberships";

export const Memberships = {
  getMemberships: () => client.get<{ list: Membership[] }>(membershipUrl),
  createMembership: (body: CreateMembershipDTO) =>
    client.post<Membership>(`${membershipUrl}/create`, body),
  updateMembership: (id: string, body: UpdateMembershipDTO) =>
    client.put<Membership>(`${membershipUrl}/update/${id}`, body),
  deleteMembership: (id: string) =>
    client.delete<{ result: string }>(`${membershipUrl}/delete/${id}`),
};
